import { rootApi } from 'root-api'

const MAX_RETRIES = 2
const RETRY_DELAY_MS = 1000

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms))

const entitlementApi = rootApi
  .enhanceEndpoints({ addTagTypes: ['NotetakerEntitlement'] })
  .injectEndpoints({
    endpoints: (build) => ({
      getNotetakerEntitlement: build.query({
        queryFn: async (_arg, _api, _extraOptions, baseQuery) => {
          const fetchEntitlement = () => baseQuery({
            url: '/api/notetaker/entitled',
          })

          const fetchWithRetry = async (retriesLeft) => {
            const result = await fetchEntitlement()
            if (result.data) {
              return { data: result.data }
            }
            if (retriesLeft === 0) {
              return { error: result.error }
            }
            await delay(RETRY_DELAY_MS)
            return fetchWithRetry(retriesLeft - 1)
          }

          return fetchWithRetry(MAX_RETRIES)
        },
        keepUnusedDataFor: 30 * 60,
        providesTags: ['NotetakerEntitlement'],
        extraOptions: {
          handleErrors: false,
          transformResponse: false,
        },
      }),
    }),
  })

export const { useGetNotetakerEntitlementQuery } = entitlementApi
